import { lazy } from "react";
const lazyShared = (name) => lazy(
  () => import("@inscore/shared").then((m) => {
    const Comp = m[name];
    if (!Comp) {
      const available = Object.keys(m).join(", ");
      throw new Error(
        `@inscore/shared: missing export "${name}". Available exports: ${available}`
      );
    }
    return { default: Comp };
  })
);
export {
  lazyShared
};
